import React from "react";
import Form from "@src/components/forms/Form";
import { Button, Divider, FormInput } from "@src/components/atoms";
import { RowEditor } from "./RowEditor";

export const SectionEditor = (props) => {
  const {
    title,
    addRow,
    addSection,
    removeSection,
    index,
    rows,
    addCol,
    removeCol,
    removeRow,
    changeColWidth,
    changeColAlign,
    dataOptions,
    behaviourOptions,
    changeColBehaviour,
    changeColGraph,
    changeContentType,
    duplicateGraphs,
    setSectionTitle,
  } = props;

  const handleAddRow = () => {
    addRow(index);
  };

  const handleAddSection = () => {
    addSection(index + 1);
  };

  const handleRemoveSection = () => {
    removeSection(index);
  };
  const handleUpdateSectionTitle = (e) => {
    setSectionTitle(e.target.value, index);
  };

  return (
    <div>
      <div className="flex flex-col">
        <div className="w-full">
          <Form>
            {(methods) => {
              return (
                <FormInput
                  label="Section Title:"
                  name="title"
                  type={"text"}
                  placeholder={""}
                  textColor={"primary"}
                  onChange={handleUpdateSectionTitle}
                  fValue={title}
                />
              );
            }}
          </Form>
        </div>
        {rows.map((row, idx) => {
          return (
            <RowEditor
              key={idx}
              index={idx}
              sectionIndex={index}
              cols={row.cols}
              addCol={addCol}
              removeCol={removeCol}
              removeRow={removeRow}
              changeColWidth={changeColWidth}
              changeColAlign={changeColAlign}
              dataOptions={dataOptions}
              behaviourOptions={behaviourOptions}
              changeColBehaviour={changeColBehaviour}
              changeContentType={changeContentType}
              changeColGraph={changeColGraph}
              duplicateGraphs={duplicateGraphs}
            />
          );
        })}
        <div className="w-full">
          <Button onClick={handleAddRow}>Add Row</Button>
          <Button onClick={handleAddSection}>Add Section</Button>
          <Button color="red" onClick={handleRemoveSection}>
            Remove Section
          </Button>
        </div>
      </div>
      <Divider />
    </div>
  );
};
